var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-advanced-wrapper" },
    [
      _c("div", { staticClass: "section-title" }, [
        _vm._v("Fixed Words & Symbols"),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "section-divider" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(_setup.CInput, {
              attrs: {
                label: "Prefix",
                placeholder: "Example: Est. [Text]",
                trim: false,
              },
              on: {
                input: function ($event) {
                  return _setup.updateElementProp("prefix", $event)
                },
              },
              model: {
                value: _setup.model.prefix,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "prefix", $$v)
                },
                expression: "model.prefix",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(_setup.CInput, {
              attrs: {
                label: "Suffix",
                placeholder: "Example: [Text] Trip",
                trim: false,
              },
              on: {
                input: function ($event) {
                  return _setup.updateElementProp("suffix", $event)
                },
              },
              model: {
                value: _setup.model.suffix,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "suffix", $$v)
                },
                expression: "model.suffix",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(_setup.CInput, {
              attrs: {
                label: "Between Characters",
                placeholder: "Example: T·E·X·T",
                trim: false,
              },
              on: {
                input: function ($event) {
                  return _setup.updateElementProp("betweenCharacters", $event)
                },
              },
              model: {
                value: _setup.model.betweenCharacters,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "betweenCharacters", $$v)
                },
                expression: "model.betweenCharacters",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(_setup.CInput, {
              attrs: {
                label: "Between Words",
                placeholder: "Example: Text ❤︎⁠ Text",
                trim: false,
              },
              on: {
                input: function ($event) {
                  return _setup.updateElementProp("betweenWords", $event)
                },
              },
              model: {
                value: _setup.model.betweenWords,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "betweenWords", $$v)
                },
                expression: "model.betweenWords",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _setup.isOFM
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(_setup.CSelect, {
                  attrs: {
                    value: _setup.model.referenceId,
                    label: "Reference ID",
                    options: _setup.melcoOptions,
                    "model-transform": _setup.valueReducer,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.handleReferenceIdChange($event)
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.isBoundedText && !_setup.hasTextShape
        ? [
            _c("div", { staticClass: "section-title" }, [_vm._v("Others")]),
            _vm._v(" "),
            _c("hr", { staticClass: "section-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "row align-items-center" }, [
              _vm.isTemplateCreation && !_setup.hasTextPathDraw
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(_setup.CCheckbox, {
                        attrs: {
                          value: _setup.model.allowEditChecked,
                          label: "Allow Moving Text",
                          disabled: !!_setup.model.autofillSource,
                        },
                        on: { input: _setup.handleAllowEditChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.forDesignTemplateCreation && !_setup.hasTextPathDraw
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(_setup.CCheckbox, {
                        attrs: {
                          value: !!_setup.model.autofillSource,
                          label: "Autofilled",
                          disabled:
                            _setup.model.useAsMask ||
                            _setup.model.useAsCutout ||
                            _setup.model.allowEditChecked,
                        },
                        on: { input: _setup.handleAutofillToggle },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c(_setup.CCheckbox, {
                    attrs: {
                      value: _setup.model.useAsMask,
                      label: "Use as Mask",
                      disabled:
                        _setup.model.useAsCutout ||
                        !!_vm.textElement?.locked ||
                        !!_setup.model.autofillSource,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.handleUseAsMaskChange($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_setup.hasTextPathDraw
                ? _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(_setup.CCheckbox, {
                        attrs: {
                          value: _setup.model.useAsCutout,
                          label: "Use as Cutout",
                          disabled:
                            _setup.model.useAsMask ||
                            !!_vm.textElement?.locked ||
                            !!_setup.model.autofillSource,
                        },
                        on: {
                          input: function ($event) {
                            return _setup.handleUseAsCutoutChange($event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _setup.isBoundedText && !_setup.hasTextPathDraw && !_setup.hasTextShape
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(_setup.CSelect, {
                  attrs: {
                    value: _setup.model.dateFormat,
                    label: "Date Format",
                    options: _setup.DATE_FORMAT_OPTIONS,
                    "model-transform": _setup.valueReducer,
                    clearable: true,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.handleDateFormatChange($event)
                    },
                  },
                }),
                _vm._v(" "),
                _setup.showDateLangWarning
                  ? _c("small", [
                      _vm._v("The month/day will be displayed in English"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.forDesignTemplateCreation && _setup.model.autofillSource
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(_setup.CSelect, {
                      attrs: {
                        value: _setup.model.autofillSource,
                        label: "Autofilled Values",
                        options: _setup.AUTOFILL_OPTIONS,
                        "model-transform": _setup.valueReducer,
                      },
                      on: {
                        input: function ($event) {
                          return _setup.handleAutofillSourceChange($event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.isBoundedText &&
      !_vm.forDesignTemplateCreation &&
      _setup.model.allowEditChecked
        ? _c("div", { staticClass: "row mt-2" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(_setup.CButton, {
                  attrs: { variant: "secondary", text: "Adjust text position" },
                  on: {
                    click: function ($event) {
                      return _setup.emit("adjust-text-position")
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }